/* Native <details> navigation: works without JavaScript. Enhancement only. */
(() => {
  if (window.__bijcNavigationV6) return;
  window.__bijcNavigationV6 = true;
  const selector = '[data-be-nav-detail], [data-be-nav-root]';
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-be-nav-detail][open], [data-be-nav-root][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
    const link = event.target.closest('a');
    if (link?.closest('.be-v6-drawer__panel')) {
      link.closest('[data-be-nav-root]')?.removeAttribute('open');
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const details = event.target.closest(selector);
    if (details?.open) {
      details.open = false;
      details.querySelector(':scope > summary')?.focus();
      event.preventDefault();
      event.stopPropagation();
    }
  });
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches(selector)) return;
    const summary = details.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', String(details.open));
    if (details.matches('[data-be-nav-root]')) summary?.setAttribute('aria-label', details.open ? (summary.dataset.closeLabel || 'Close navigation') : (summary.dataset.openLabel || 'Open navigation'));
    if (details.open && details.matches('[data-be-nav-detail]')) {
      details.parentElement?.querySelectorAll(':scope > [data-be-nav-detail][open]').forEach((other) => {
        if (other !== details) other.open = false;
      });
    }
  }, true);
})();
